import React from "react";
import { connect } from "react-redux";
import {
  toggleCartSidebar,
  updateQuantity,
  removeFromCart,
} from "../redux/actions/cartActions";
import { Link } from "react-router-dom";

const CartSidebar = ({
  cart,
  toggleCartSidebar,
  updateQuantity,
  removeFromCart,
}) => {
  const { items, isCartSidebarOpen } = cart;

  // Calculate subtotal
  const subtotal = items.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );
  return (
    <div
      className={`fixed top-0 right-0 h-full w-96 bg-white shadow-lg transform transition-transform ${
        isCartSidebarOpen ? "translate-x-0" : "translate-x-full"
      } z-50`}
    >
      <div className="flex flex-col justify-between h-full">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <h2 className="text-xl font-bold">Shopping Cart</h2>
          <button
            className="text-gray-500 hover:text-gray-800"
            onClick={toggleCartSidebar}
          >
            ✖
          </button>
        </div>

        {/* Cart Items */}
        <div className="p-3 space-y-4 overflow-y-auto h-full">
          {items.length ? (
            items.map((item, index) => (
              <div key={index} className="flex items-start border-b pb-4">
                <img
                  src={item.image}
                  alt={item.name}
                  className="md:w-32 md:h-32 w-16 h-16 object-cover rounded"
                />
                <div className="flex flex-col ps-2 md:ps-3">
                  <div className="flex-1">
                    <h3 className="text-sm font-medium truncate">
                      {item.name}
                    </h3>
                    <p className="text-sm font-bold">Rs. {item.price}</p>
                    <p className="text-xs text-gray-500">Size: {item.size}</p>
                  </div>
                  <div>
                    <div className="flex items-center space-x-2">
                      {/* Quantity Controls */}
                      <button
                        className=""
                        onClick={() =>
                          updateQuantity(
                            item.id,
                            item.size,
                            item.color,
                            item.quantity - 1
                          )
                        }
                        disabled={item.quantity === 1}
                      >
                        <i className="fa-solid fa-circle-minus"></i>
                      </button>
                      <span className="px-2">{item.quantity}</span>
                      <button
                        className=""
                        onClick={() =>
                          updateQuantity(
                            item.id,
                            item.size,
                            item.color,
                            item.quantity + 1
                          )
                        }
                      >
                        <i className="fa-solid fa-circle-plus"></i>
                      </button>
                    </div>
                    <button
                      className="text-red-500 hover:text-red-700"
                      onClick={() => removeFromCart(item.id, item.size)}
                    >
                      🗑
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-500">Your cart is empty.</p>
          )}
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-gray-200">
          <div className="flex justify-between text-lg font-semibold mb-4">
            <span>Subtotal:</span>
            <span>Rs. {subtotal.toLocaleString()}</span>
          </div>
          <div className="space-y-2">
            <button
              onClick={toggleCartSidebar}
              className="w-full py-2 bg-black text-white rounded-lg font-medium"
            >
              <Link to={"/cart"}>View Cart</Link>
            </button>
            <button
              onClick={toggleCartSidebar}
              className="w-full py-2 bg-black text-white rounded-lg font-medium"
            >
              {items.length > 0 ? (
                <Link to="/checkout">Checkout</Link>
              ) : (
                "Checkout"
              )}
            </button>
            <button
              onClick={toggleCartSidebar}
              className="w-full py-2 bg-gray-100 text-black rounded-lg font-medium"
            >
              <Link to={"/"}>Continue Shopping</Link>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  cart: state.cart,
});

const mapDispatchToProps = {
  toggleCartSidebar,
  updateQuantity,
  removeFromCart,
};

export default connect(mapStateToProps, mapDispatchToProps)(CartSidebar);
